window.addEventListener('load', () => {
    const utmvars = getUtmValues();
    let utmconverted = setUtmValues(utmvars);
    appendUtmQueries(
        readCookie('utm_source'),
        readCookie('utm_medium'),
        readCookie('utm_campaign'),
        readCookie('utm_content')
    );
});

function gtmPush(event, formId) {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: event,
            formName: formId
        });
    }
}

function appendUtmQueries(source, medium, campaign, content) {
    const data = {
        'utm_source': source,
        'utm_medium': medium,
        'utm_campaign': campaign,
        'utm_content': content,
    }
    let urlParts = [];

    for (let key of Object.keys(data)) {
        if (data[key]) {
            const encodedValue = encodeURIComponent(data[key]);
            urlParts.push(`${key}=${encodedValue}`);
        }
    }

    if (urlParts.length) {
        const queryString = urlParts.join('&');

        document.querySelectorAll('.append-utm').forEach((element) => {
            element.href += `?${queryString}`;
        });
    }
}

function getUtmValues() {
    let queryString = window.location.search || '';
    var keyValPairs = [];
    var params = {};
    queryString = queryString.substr(1);

    if (queryString.length) {
        keyValPairs = queryString.split('&');
        for (let pairNum in keyValPairs) {
            var key = keyValPairs[pairNum].split('=')[0];
            if (!key.length) {
                continue;
            }
            if (typeof params[key] === 'undefined') {
                params[key] = [];
            }
            params[key].push(keyValPairs[pairNum].split('=')[1]);
        }
    }

    return params;
}

function setUtmValues(queryParams) {
    if ('utm_source' in queryParams) {
        createCookie('utm_source', queryParams['utm_source'][0], 7);
    }
    if ('utm_medium' in queryParams) {
        createCookie('utm_medium', queryParams['utm_medium'][0], 7);
    }
    if ('utm_campaign' in queryParams) {
        createCookie('utm_campaign', queryParams['utm_campaign'][0], 7);
    }
    if ('utm_content' in queryParams) {
        createCookie('utm_content', queryParams['utm_content'][0], 7);
    }

    let hiddenFields = document.querySelectorAll('input[type=hidden]');
    for (let hiddenField of hiddenFields) {
        let inputName = hiddenField.getAttribute('name');

        if (inputName === 'UTMSOURCE') {
            hiddenField.value = readCookie('utm_source');
        } else if (inputName === 'UTMMEDIUM') {
            hiddenField.value = readCookie('utm_medium');
        } else if (inputName === 'UTMCAMP') {
            hiddenField.value = readCookie('utm_campaign');
        } else if (inputName === 'UTMCONTENT') {
            hiddenField.value = readCookie('utm_content');
        }
    }
}

// Create cookie
function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var expires = '; expires=' + date.toGMTString();
    } else var expires = '';
    document.cookie = name + '=' + value + expires + '; path=/';
}

// Read cookie
function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}